/* import __COLOCATED_TEMPLATE__ from './side-sheet.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import templateOnlyComponent from '@ember/component/template-only';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';
import type Workflow from 'embercom/models/operator/visual-builder/workflow';

interface Signature {
  Args: {
    editorState: EditorState;
    workflow: Workflow;
  };
}

const VersionHistorySideSheet = templateOnlyComponent<Signature>();
export default VersionHistorySideSheet;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::VersionHistory::SideSheet': typeof VersionHistorySideSheet;
    'workflows/version-history/side-sheet': typeof VersionHistorySideSheet;
  }
}
